<template>
  <div class="xenon">
    <b-spinner v-if="loadingTable" class="xenon__spinner"> </b-spinner>
    <div :key="renderXenonTable" class="xenon-table" v-else>
      <h3>Table Xenon</h3>
      <h5>Destination: {{ destination }}</h5>
      <div class="xenon-container">
        <div>
          <div class="xenon-container__sections-type">
            <strong>Service Type:</strong>
            <b-form-select
              v-model="serviceTypeSelected"
              :options="serviceTypeOptions"
              :disabled="loadingInfo"
              required
            ></b-form-select>
          </div>
          <div class="xenon-container__sections-type">
            <strong>Equipment Type:</strong>
            <b-form-select
              v-model="equipmentTypeSelected"
              :options="equipmentTypeOptions"
              :disabled="loadingInfo"
              required
            ></b-form-select>
          </div>
        </div>
        <div>
          <div class="xenon-container__sections-type">
            <strong>Size:</strong>
            <b-form-select
              v-model="containerSizesSelected"
              :options="containerSizesOptions"
              :disabled="loadingInfo"
              required
            ></b-form-select>
          </div>
          <b-form-checkbox
            v-model="hazmatCheckbox"
            :disabled="loadingInfo"
            class="xenon-container__sections-type"
            >Hazmat</b-form-checkbox
          >
          <b-form-checkbox
            :disabled="loadingInfo"
            v-model="overweightCheckbox"
            class="xenon-container__sections-type"
            >Overweight</b-form-checkbox
          >
        </div>
        <b-overlay
          :show="sendingInfo"
          variant="white"
          spinner-variant="primary"
          opacity="0.6"
          spinner-small
        >
          <b-button
            class="xenon-container__send-sections-type"
            variant="primary"
            @click="sendTypeSections"
            >Send</b-button
          >
        </b-overlay>
      </div>
      <b-table
        id="xenon-table"
        class="text-left"
        responsive
        :items="details"
        :fields="fields"
      >
        <template class="rate" #cell(rate)="row">
          <b-tr class="rate__xenon-options">
            <b-td
              class="rate__option"
              v-for="(option, index) in options"
              :key="index"
            >
              <span v-if="row.item.details == 'Rate #'"
                >Option {{ index + 1 }}</span
              >
              <div
                :id="'rate-table' + index"
                class="d-flex flex-row"
                v-if="row.item.details == 'Port/Ramp'"
              >
                <!--               <b-button variant="link" size="sm" squared v-b-modal.modal-2
                  ><i class="fa fa-plus"></i
                ></b-button> -->
                <b-form-input
                  v-model="rampSelected[index]"
                  @change="updateRamp(index)"
                  size="sm"
                  list="rampOptions"
                  autocomplete="off"
                  :disabled="loadingInfo"
                ></b-form-input>

                <datalist id="rampOptions">
                  <option
                    v-for="(rampOption, index) in rampOptions"
                    :key="index"
                  >
                    {{ rampOption.name }}
                  </option>
                </datalist>
              </div>
              <span v-if="row.item.details == 'Total Miles'">{{
                totalMiles[index]
              }}</span>
              <div v-if="row.item.details == 'Xenon Rate'">
                <b-button
                  @click="showCard(index)"
                  v-model="visible[index]"
                  class="rate__detail-button"
                  aria-controls="collapse"
                  variant="link"
                  squared
                  >{{ visible[index] ? "-" : "+" }}</b-button
                >
                <h6>
                  <b> Total:</b>
                  ${{ totalRate[index]
                  }}<b-spinner
                    v-show="changeRamp[index] == index"
                    type="grow"
                    variant="primary"
                    small
                  ></b-spinner>
                </h6>
                <b-collapse v-model="visible[index]" id="collapse" class="mt-2">
                  <b-card>
                    <ul
                      class="rate__quote-value-list"
                      v-show="quotesValue[index] !== null"
                      v-for="(quoteValue, i) in quotesValue[index]"
                      :key="i"
                    >
                      <li>
                        <b>{{ quoteValue.description }}:</b>
                        {{ quoteValue.amount }}
                      </li>
                    </ul>
                  </b-card>
                </b-collapse>
              </div>

              <b-button
                class="rate__expected-cost"
                v-if="row.item.details == 'Send to:'"
                :disabled="updatingExpectedCost"
                @click="valueExpectedCost(index)"
                >Expected Cost
                <b-spinner
                  v-show="updateExpectedCost.index == index"
                  small
                ></b-spinner
              ></b-button>
            </b-td>
          </b-tr>
        </template>
      </b-table>
    </div>
    <!--     <b-modal id="modal-2" ok-only centered>
      <b-table hover :items="items" :fields="column"></b-table>
    </b-modal> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    tripNumber: Number,
    pickupAndDelivery: Array
  },
  data() {
    return {
      cities: null,
      serviceTypeSelected: null,
      serviceTypeOptions: [],
      equipmentTypeSelected: null,
      equipmentTypeOptions: [],
      containerSizesSelected: null,
      containerSizesOptions: [],
      options: ["Option1", "Option2", "Option3", "Option4", "Option5"],
      fields: ["details", "rate"],
      details: [
        { details: "Rate #" },
        { details: "Port/Ramp" },
        { details: "Total Miles" },
        { details: "Xenon Rate" },
        { details: "Send to:" }
      ],
      rampSelected: [],
      rampOptions: [],
      rampId: [],
      /* infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      }, */
      // column: ["port_ramp"],
      // items: [{ port_ramp: "" }],
      visible: { index: false },
      portsRamps: null,
      totalMiles: [],
      destination: "",
      quotesValue: {},
      hazmatCheckbox: false,
      overweightCheckbox: false,
      copyQuotesValue: null,
      totalRate: [],
      renderXenonTable: 0,
      sendingInfo: false,
      updateExpectedCost: { index: null },
      updatingExpectedCost: false,
      changeRamp: { 0: null, 1: null, 2: null, 3: null, 4: null },
      loadingTable: true,
      xenonCityInfo: null,
      loadingInfo: false
    };
  },
  mounted() {
    this.xenonCityInfo = this.showXenonCityInfo;
    this.loadingTable = !!this.showXenonCityInfo;
    this.xenonTableInfo();
  },
  computed: {
    ...mapGetters("quotes/xenon", ["showXenonCityInfo"])
  },
  watch: {
    pickupAndDelivery: {
      deep: true,
      handler() {
        this.destination = this.pickupAndDelivery[
          this.tripNumber - 1
        ].to.city_to;
      }
    },
    showXenonCityInfo(value) {
      this.xenonCityInfo = value;
      this.xenonTableInfo();
    }
  },
  methods: {
    async xenonTableInfo() {
      this.sendingInfo = true;
      this.loadingInfo = true;
      this.updatingExpectedCost = true;
      this.changeRamp = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4 };
      this.destination = this.pickupAndDelivery[this.tripNumber - 1].to.city_to;
      if (this.xenonCityInfo) {
        this.quotesValue = {};
        this.copyQuotesValue = null;
        this.totalRate = [];
        let portsRampsInfo = {};
        portsRampsInfo.cityId = this.xenonCityInfo.id;
        portsRampsInfo.piersOnly = false;
        portsRampsInfo.includeAllPortsRamps = false;
        this.portsRamps = await this.$store.dispatch(
          "quotes/xenon/getPortsRamps",
          portsRampsInfo
        );
        if (this.portsRamps.status == 200) {
          this.rampOptions = this.portsRamps.data;
          for (let j = 0; j < 5; j++) {
            this.rampSelected[j] = this.rampOptions[j].name;
            this.rampId[j] = this.rampOptions[j].id;
            this.totalMiles[j] = this.rampOptions[j].miles;
          }
        }

        await this.typeSections();
        await this.xenonRateInfo();
      }
    },
    async typeSections() {
      // Esta petición lanza el valor de "import" y "export" y hasta el momento se manda en "export"
      await this.$store.dispatch("quotes/xenon/getTransationsTypes");
      let servicesTypes = await this.$store.dispatch(
        "quotes/xenon/getServicesTypes"
      );
      this.serviceTypeOptions = servicesTypes.data;
      let containerTypes = await this.$store.dispatch(
        "quotes/xenon/getContainerTypes"
      );
      this.equipmentTypeOptions = containerTypes.data;
      let containerSizes = await this.$store.dispatch(
        "quotes/xenon/getContainerSizes"
      );
      this.containerSizesOptions = containerSizes.data;
      this.containerSizesOptions.unshift("ALL");
      this.serviceTypeSelected = this.serviceTypeOptions[0];
      this.equipmentTypeSelected = this.equipmentTypeOptions[0];
      this.containerSizesSelected = this.containerSizesOptions[0];
    },
    sendTypeSections() {
      this.sendingInfo = true;
      this.loadingInfo = true;
      this.updatingExpectedCost = true;
      this.changeRamp = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4 };
      this.quotesValue = {};
      this.copyQuotesValue = null;
      this.totalRate = [];
      this.xenonRateInfo();
    },
    async xenonRateInfo() {
      let totalRateAux = [];
      for (let i = 0; i < 5; i++) {
        let xenonRateInfo = {};
        xenonRateInfo.transactionType = "export";
        xenonRateInfo.serviceType = this.serviceTypeSelected;
        xenonRateInfo.containerType = this.equipmentTypeSelected;
        xenonRateInfo.originDestination = this.xenonCityInfo.id;
        xenonRateInfo.portRamp = this.rampId[i];
        xenonRateInfo.containerSize = this.containerSizesSelected;
        xenonRateInfo.overweight = this.overweightCheckbox;
        xenonRateInfo.hazardous = this.hazmatCheckbox;
        let response = await this.$store.dispatch(
          "quotes/xenon/getXenon",
          xenonRateInfo
        );
        if (response.status == 200) {
          this.quotesValue[i] = response.data.rates;
          for (let k in this.quotesValue) {
            for (let j in this.quotesValue[k]) {
              this.copyQuotesValue = this.quotesValue[k];
              if (!this.hazmatCheckbox) {
                if (this.quotesValue[k][j].description == "Hazmat") {
                  this.copyQuotesValue.splice(j, 1);
                }
              }
              if (!this.overweightCheckbox) {
                if (this.quotesValue[k][j].description == "Triaxle Charge") {
                  this.copyQuotesValue.splice(j, 1);
                }
              }
              if (this.quotesValue[k][j].description == "Total") {
                this.copyQuotesValue.splice(-1);
              }
            }
          }
        }
        let sumTotal = [];
        for (
          let element = 0;
          element < this.copyQuotesValue.length;
          element++
        ) {
          sumTotal.push(this.copyQuotesValue[element].amount);
          totalRateAux[i] = sumTotal.reduce((a, b) => a + b, 0);
        }
        this.totalRate.push(totalRateAux[i].toFixed(2));
        this.changeRamp[i] = null;
        this.renderXenonTable += 1;
        this.updatingExpectedCost = false;
      }
      this.sendingInfo = false;
      this.loadingInfo = false;
      this.loadingTable = false;
    },
    // resetInfoModal() {
    //   this.infoModal.title = "";
    //   this.infoModal.content = "";
    // },
    showCard(index) {
      this.visible[index] = !this.visible[index];
    },
    async updateRamp(index) {
      this.changeRamp[index] = index;
      for (let rampOption of this.rampOptions) {
        if (rampOption.name == this.rampSelected[index]) {
          this.totalMiles[index] = rampOption.miles;
          this.rampId[index] = rampOption.id;
          this.renderXenonTable += 1;
        }
      }
      // Para optimización
      await this.updateXenonRateInfo(index);
      this.changeRamp[index] = null;
    },
    async updateXenonRateInfo(index) {
      this.quotesValue[index] = null;
      this.copyQuotesValue = null;
      this.totalRate[index] = 0;
      let xenonRateInfo = {};
      xenonRateInfo.transactionType = "export";
      xenonRateInfo.serviceType = this.serviceTypeSelected;
      xenonRateInfo.containerType = this.equipmentTypeSelected;
      xenonRateInfo.originDestination = this.xenonCityInfo.id;
      xenonRateInfo.portRamp = this.rampId[index];
      xenonRateInfo.containerSize = this.containerSizesSelected;
      xenonRateInfo.overweight = this.overweightCheckbox;
      xenonRateInfo.hazardous = this.hazmatCheckbox;
      let response = await this.$store.dispatch(
        "quotes/xenon/getXenon",
        xenonRateInfo
      );
      if (response.status == 200) {
        this.quotesValue[index] = response.data.rates;
        this.copyQuotesValue = this.quotesValue;
        for (let j in this.copyQuotesValue[index]) {
          if (!this.hazmatCheckbox) {
            if (this.copyQuotesValue[index][j].description == "Hazmat") {
              this.copyQuotesValue[index].splice(j, 1);
            }
          }
          if (!this.overweightCheckbox) {
            if (
              this.copyQuotesValue[index][j].description == "Triaxle Charge"
            ) {
              this.copyQuotesValue[index].splice(j, 1);
            }
          }
          if (this.copyQuotesValue[index][j].description == "Total") {
            this.copyQuotesValue[index].splice(-1);
          }
        }
        let sumTotal = [];
        for (
          let element = 0;
          element < this.copyQuotesValue[index].length;
          element++
        ) {
          sumTotal.push(this.copyQuotesValue[index][element].amount);
          this.totalRate[index] = sumTotal.reduce((a, b) => a + b, 0);
        }
        this.totalRate[index] = this.totalRate[index].toFixed(2);
        this.renderXenonTable += 1;
      }
    },
    async valueExpectedCost(index) {
      this.updateExpectedCost.index = index;
      this.updatingExpectedCost = true;
      let info = {};
      let haulInformation = this.$store.getters["quotes/quote/showQuoteById"]
        .haul;
      info.haulId = haulInformation[this.tripNumber - 1].id;
      info.payload = {};
      info.payload.expected_cost = this.totalRate[index];
      await this.$store.dispatch("quotes/haul/updateHaul", info);
      this.$store.commit("quotes/xenon/setExpectedCost", this.totalRate[index]);
      this.updateExpectedCost.index = null;
      this.updatingExpectedCost = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.xenon-table {
  @include card;
  margin-top: 1rem;
}
.xenon-container {
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  text-align: start;
  &__sections-type {
    margin: 1rem 0;
  }
  &__send-sections-type {
    height: 2.5rem;
  }
}
td {
  border-top: none !important;
}
.rate {
  &__option {
    width: 100%;
    border-left: 1px solid #dee2e6;
    display: flex;
    flex-direction: column;
  }
  &__xenon-options {
    display: flex;
    justify-content: space-around;
  }
  &__quote-value-list {
    list-style: none;
    padding: 0;
    font-size: 12px;
  }
  &__expected-cost {
    font-size: 12px;
  }
  &__detail-button {
    font-size: 25px;
    border: none;
    outline: none;
    &:hover {
      text-decoration: none;
      border: none;
      outline: none;
    }
    &:focus {
      text-decoration: none;
      border: none;
      outline: none;
    }
  }
}
</style>
